import {useReducer} from "react";
import reducer from "./reducer";
import DonationContext, {internalState} from "./context";
import {execute} from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {IDonation} from "../../models/donation/response";
import {IDonationQuery} from "../../models/donation/query";

export interface IProps {
    children: React.ReactNode;
}

const DonationContextProvider: React.FC<IProps> = (props) => {
    const [state, dispatch] = useReducer(reducer, internalState)

    const getData = async () => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
                const { data } = await EndPoints.donation.getAllDonations(state.query);
                dispatch({ type: "SET_LIST", payload: { list: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
            },
            throwException: false,
        });
    };

    const getDetails = async (id: number) => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });

                const { data } = await EndPoints.donation.getDonation(id);
                dispatch({ type: "SET_DETAILS", payload: { details: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });
            },
            throwException: false,
        });
    };

    const setDetails = async (data?: IDonation) => {
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
    };

    const setSearch = (search?: string) => {
        dispatch({ type: "SET_SEARCH", payload: { search } });
    };

    const setQuery = (query: IDonationQuery) => {
        dispatch({ type: "SET_QUERY", payload: { query } });
    };

    return (
        <DonationContext.Provider
            value={{
                ...state,
                actions: {
                    getData,
                    getDetails,
                    setDetails,
                    setSearch,
                    setQuery,
                }
            }}
        >
            {props.children}
        </DonationContext.Provider>
    )
}

export default DonationContextProvider;